<template>
    <v-menu offset-y eager>
        <!-- User Button -->
        <template v-slot:activator="{ on: menu, attrs }">
            <v-btn
                text
                v-bind="attrs"
                v-on="menu"
                class="px-1 primary--text"
                style="min-width: 40px;"
            >
                <v-icon>mdi-account</v-icon>
                <!-- {{userInfo.name.firstname}} -->
            </v-btn>
        </template>

        <v-list dense style="max-width: 250px;">
            <!-- User Info -->
            <v-list-item to="/myaccount"> <!--go to myaccount-->
                <v-list-item-avatar v-if="userInfo.profileImage">
                    <v-img :src="profileImage" eager class="grey lighten-2"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title v-if="userInfo.name.displayname" class="font-weight-medium">
                        {{userInfo.name.displayname}}
                    </v-list-item-title>
                    <v-list-item-title v-else class="font-weight-medium">
                        {{userInfo.name.firstname}} {{userInfo.name.lastname}}
                    </v-list-item-title>
                    <v-list-item-subtitle>{{userInfo.email}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <!-- Selling Product -->
            <v-list-item to="/mystore/product" exact>
                <v-list-item-title>
                    <v-icon left>add</v-icon>{{ $langs.UserMenu.sellPet[$langs.lang] }}
                </v-list-item-title>
            </v-list-item>

             <!-- My Store -->
            <v-list-item to="/mystore/store" exact v-if="storeInfo">
                <v-list-item-title>
                    <v-icon left>mdi-storefront-outline</v-icon>{{ $langs.MyStore.myStore[$langs.lang] }}
                </v-list-item-title>
            </v-list-item>

            <!-- My Order -->
            <!-- <v-list-item disabled>
                <v-list-item-title>
                    <v-icon left>mdi-cart-outline</v-icon>My Order ( Developing )
                </v-list-item-title>
            </v-list-item> -->

            <!-- For Admin Only -->
            <v-list-item v-if="userInfo && userInfo.type == 'admin'" to="/admin">
                <v-list-item-title>
                    <v-icon left>mdi-cog-outline</v-icon>Admin Panel
                </v-list-item-title>
            </v-list-item>

            <!-- Logout -->
            <v-list-item @click="logout()">
                <v-list-item-title>
                    <v-icon left>mdi-export</v-icon>{{ $langs.Auth.logout[$langs.lang] }}
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import { mapState } from "vuex";
import router from "@/router"
import store from "@/store"
import user from "@/services/user";
import api from "@/services/api";
import { userImageUrl } from "@/services/constants";

export default {
    methods: {
        logout() {
            this.$store.dispatch("Logout");
            // if (this.$route.path !== "/") this.$router.push("/");
            api.makeAlert(`You have been logged out.`, 'success');
            setTimeout(() => this.$router.go(), 700);
        },
        async checkToken() {
            if (user.isTokenExpire() && !(await user.renewToken())) {
                // push user to /login + make alert
                router.push("/login");
                store.dispatch("Logout");
                api.makeAlert('Session timeout, Please login', 'secondary');
            }
        }
    },
    computed: {
        ...mapState(["userInfo", "storeInfo"]),
        profileImage() {
            return userImageUrl(this.userInfo.profileImage);
        }
    }
};
</script>

<style>
</style>